import { IFormlyConfig } from "AngularFormly";

export const vsWrapperName = "processLabel";

labelWrapperConfig.$inject = ["formlyConfigProvider"];
export function labelWrapperConfig(formlyConfigProvider: IFormlyConfig) {
  formlyConfigProvider.setWrapper({
    name: vsWrapperName,
    template: require("!html-loader!./index.html").default,
  });
}
